export default "__VITE_ASSET__77b78a01__"